import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-87b0bcb2")

_pushScopeId("data-v-87b0bcb2")
const _hoisted_1 = { class: "detail-footer-view" }
const _hoisted_2 = { class: "detail-footer-view-note-view-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        innerHTML: _ctx.note,
        class: "detail-footer-view-note-view"
      }, null, 8, ["innerHTML"])
    ])
  ], 512)), [
    [_vShow, _ctx.note]
  ])
})